import { JobExperience } from '@/types/job';

const CANONICAL_VALUES = new Set<string>(Object.values(JobExperience));

export const normalizeJobExperience = (
	value: unknown
): JobExperience | null => {
	if (typeof value !== 'string') return null;
	return CANONICAL_VALUES.has(value) ? (value as JobExperience) : null;
};
